<ng-container *t="let t">
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="!data.model.id"
        i18n="@@5247d47a2f32aa7657a14a45671aca5ac80317eb"
        t="5247d47a2f32aa7657a14a45671aca5ac80317eb"
        >Add Product Experience</h3
    >
    <h3
        class="form-header"
        mat-dialog-title
        *ngIf="data.model.id"
        i18n="@@10a86a7c4a75a4c8a2635611c3079bb76386c5ac"
        t="10a86a7c4a75a4c8a2635611c3079bb76386c5ac"
        >Edit Product Experience</h3
    >

    <div class="grid" [formGroup]="editForm">
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@bb30675f24a583478f802b6baec7cf189ba89b65"
                        t="bb30675f24a583478f802b6baec7cf189ba89b65"
                        >Commodity</tsl-label
                    >
                    <tsl-select fullWidth required formControlName="commodity">
                        <tsl-option *ngFor="let item of commodities" [value]="item.id">{{
                            translate.get(item.description)
                        }}</tsl-option>
                    </tsl-select>
                    <tsl-hint
                        align="end"
                        i18n="@@22bcde613ebe4f9d940770285784d30902a2343e"
                        t="22bcde613ebe4f9d940770285784d30902a2343e"
                        >Commodity Supplier has worked with</tsl-hint
                    >
                </tsl-form-field>
            </div>
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@97d3ced38caacd5e528e62d9c9f81a03f02ed7d8"
                        t="97d3ced38caacd5e528e62d9c9f81a03f02ed7d8"
                        >Years of Experience</tsl-label
                    >
                    <input tslInput fullWidth required type="number" min="0" formControlName="years" />
                    <tsl-hint
                        align="end"
                        i18n="@@f3c99d7ffb81786777ed3716284eba75c2a0e7e3"
                        t="f3c99d7ffb81786777ed3716284eba75c2a0e7e3"
                        >Years of experience working with it</tsl-hint
                    >
                </tsl-form-field>
            </div>
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@b116ca6e8a90a9318f2b2c75a7bd8c5a7b2a7da5"
                        t="b116ca6e8a90a9318f2b2c75a7bd8c5a7b2a7da5"
                        >Total Parts</tsl-label
                    >
                    <input tslInput fullWidth type="number" min="0" formControlName="parts" />
                    <tsl-hint
                        align="end"
                        i18n="@@963659305b030b99dd6f0833d23544776f7e0398"
                        t="963659305b030b99dd6f0833d23544776f7e0398"
                        >Total no of parts Supplier has worked with</tsl-hint
                    >
                </tsl-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@84883bf9ad5dc890c4c72686858df4b47dd5a321"
                        t="84883bf9ad5dc890c4c72686858df4b47dd5a321"
                        >Revenue Percentage</tsl-label
                    >
                    <input tslInput fullWidth type="number" min="0" formControlName="revenue" />
                    <tsl-hint
                        align="end"
                        i18n="@@0d373fe10013206d54d987a1da3f7872f73a0d7c"
                        t="0d373fe10013206d54d987a1da3f7872f73a0d7c"
                        >Percentage of revenue</tsl-hint
                    >
                </tsl-form-field>
            </div>
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@fd7c8b53e0ddf22b4f056688a48cc1cdb8457535"
                        t="fd7c8b53e0ddf22b4f056688a48cc1cdb8457535"
                        >Production Volume</tsl-label
                    >
                    <input tslInput fullWidth type="number" min="0" formControlName="volume" />
                    <tsl-hint
                        align="end"
                        i18n="@@351adb4aa110a36a90c2ebe96f3ab3d0eac4582d"
                        t="351adb4aa110a36a90c2ebe96f3ab3d0eac4582d"
                        >Parts per year Supplier can deliver</tsl-hint
                    >
                </tsl-form-field>
            </div>
            <div fxFlex>
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@48dfc41ca42e626d511f0307bd4c88f047a92b07"
                        t="48dfc41ca42e626d511f0307bd4c88f047a92b07"
                        >Quote for new parts</tsl-label
                    >
                    <input tslInput fullWidth type="number" min="0" formControlName="quote" />
                    <tsl-hint
                        align="end"
                        i18n="@@8e169b3fbdb63ea4c98ce8829a9f7cab0faed76e"
                        t="8e169b3fbdb63ea4c98ce8829a9f7cab0faed76e"
                        >Number of weeks to deliver</tsl-hint
                    >
                </tsl-form-field>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex="33">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@ee24e2b11df689fc07d93cae38b648fa2f10f892"
                        t="ee24e2b11df689fc07d93cae38b648fa2f10f892"
                        >Does Production</tsl-label
                    >
                    <tsl-select fullWidth formControlName="doesProduction">
                        <tsl-option [value]="true" i18n="@@Yes" t="Yes">Yes</tsl-option>
                        <tsl-option [value]="false" i18n="@@No" t="No">No</tsl-option>
                    </tsl-select>
                    <tsl-hint
                        align="end"
                        i18n="@@b0836121a07a1e3981f87e79ece3ba0f94b3eb8a"
                        t="b0836121a07a1e3981f87e79ece3ba0f94b3eb8a"
                        >Can Supplier work on production parts?</tsl-hint
                    >
                </tsl-form-field>
            </div>
            <div fxFlex="33">
                <tsl-form-field fxFlex>
                    <tsl-label
                        i18n="@@bea198e9b89e7ac8346be088b05b12932a79989d"
                        t="bea198e9b89e7ac8346be088b05b12932a79989d"
                        >Does Prototype</tsl-label
                    >
                    <tsl-select fullWidth formControlName="doesPrototype">
                        <tsl-option [value]="true" i18n="@@Yes" t="Yes">Yes</tsl-option>
                        <tsl-option [value]="false" i18n="@@No" t="No">No</tsl-option>
                    </tsl-select>
                    <tsl-hint
                        align="end"
                        i18n="@@4245d6a712de51eb4bf19bcd39a82f2fd97ad48f"
                        t="4245d6a712de51eb4bf19bcd39a82f2fd97ad48f"
                        >Can Supplier work on prototype parts?</tsl-hint
                    >
                </tsl-form-field>
            </div>
        </div>
    </div>
    <mat-tab-group class="dialog-content">
        <mat-tab label="Tools">
            <div class="inside-container" fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px">
                    <!-- <div fxFlex="25">
                        <tsl-form-field fxFlex>
                            <tsl-label>Tool Category</tsl-label>
                            <tsl-select fullWidth
                                 
                                formControlName="category"
                                (selectionChange)="onSelectCategory($event, true)">
                                <tsl-option *ngFor="let item of categories" [value]="item.id">{{item.category}}</tsl-option>
                            </tsl-select>
                        </tsl-form-field>
                    </div>

                    <div fxFlex="25">
                        <tsl-form-field fxFlex>
                            <tsl-label>Tool Subcategory</tsl-label>
                            <tsl-select fullWidth
                                
                                formControlName="subcategory"
                                (selectionChange)="onSelectSubcategory($event, true)">
                                <tsl-option *ngFor="let item of filteredToolSubcategories$ | async" [value]="item.id">{{item.subcategory}}</tsl-option>
                            </tsl-select>
                        </tsl-form-field>
                    </div> -->

                    <div fxFlex="40">
                        <tsl-form-field fxFlex>
                            <tsl-label
                                i18n="@@fefee13017c2b85143cd131ee253e327a14053a0"
                                t="fefee13017c2b85143cd131ee253e327a14053a0"
                                >Tools</tsl-label
                            >
                            <tsl-select fullWidth [(ngModel)]="selectedTool">
                                <tsl-option *ngFor="let item of tools" [value]="item">{{
                                    translate.get(item.data.name)
                                }}</tsl-option>
                            </tsl-select>
                        </tsl-form-field>

                        <button
                            tsl-button
                            color="black"
                            size="small"
                            outline
                            (click)="onAddTool(true)"
                            style="margin: 24px; "
                            i18n="@@9e9736df43e489e23c4518f62b387fa12ace4f5a"
                            t="9e9736df43e489e23c4518f62b387fa12ace4f5a"
                            >Add
                        </button>
                    </div>
                </div>

                <mat-accordion [multi]="true">
                    <mat-expansion-panel *ngFor="let item of data.model.tools">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ translate.get(item.toolName) }}</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div>
                            <div fxFlex>
                                <table class="services" fxFlex>
                                    <thead>
                                        <tr>
                                            <th
                                                i18n="@@651956f272ff2f37fbc236e2eef45d1283e87383"
                                                t="651956f272ff2f37fbc236e2eef45d1283e87383"
                                                >Capability Type</th
                                            >
                                            <th
                                                i18n="@@2aa3e81e045266e888ee95684dea616982085892"
                                                t="2aa3e81e045266e888ee95684dea616982085892"
                                                >Internal Production Tool</th
                                            >
                                            <th
                                                i18n="@@255a3de663e5cba73a6479d8cebe4ceb5117b495"
                                                t="255a3de663e5cba73a6479d8cebe4ceb5117b495"
                                                >Internal Prototype Tool</th
                                            >
                                            <th
                                                i18n="@@622dad26f8620b8911e4a59092e9d4f276be069c"
                                                t="622dad26f8620b8911e4a59092e9d4f276be069c"
                                                >Outsource Production Tool</th
                                            >
                                            <th
                                                i18n="@@e6c30beb07fba03f31b3dcd212ceaa9f3e2da557"
                                                t="e6c30beb07fba03f31b3dcd212ceaa9f3e2da557"
                                                >Outsource Prototype Tool</th
                                            >
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td
                                                i18n="@@e0535f9c6a0c61be171755fc908330184d2308d3"
                                                t="e0535f9c6a0c61be171755fc908330184d2308d3"
                                                >Build (weeks lead time)</td
                                            >
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.internalProductionCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox1 tslTooltip="{{ t('4156336694929866466', checkBox1) }}"
                                                    >
                                                    </tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.internalProductionCapable"
                                                        [(ngModel)]="item.buildService.internalProductionTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.internalPrototypeCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox2 tslTooltip="{{ t('4156336694929866466', checkBox2) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.internalPrototypeCapable"
                                                        [(ngModel)]="item.buildService.internalPrototypeTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.outsourceProductionCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox3 tslTooltip="{{ t('4156336694929866466', checkBox3) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.outsourceProductionCapable"
                                                        [(ngModel)]="item.buildService.outsourceProductionTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.outsourcePrototypeCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox4 tslTooltip="{{ t('4156336694929866466', checkBox4) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.outsourcePrototypeCapable"
                                                        [(ngModel)]="item.buildService.outsourcePrototypeTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                i18n="@@695cae7988045be57f186ab95b9f2ddc1c98b5e6"
                                                t="695cae7988045be57f186ab95b9f2ddc1c98b5e6"
                                                >Repair</td
                                            >
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.internalProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox5 tslTooltip="{{ t('4156336694929866466', checkBox5) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.internalPrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox6 tslTooltip="{{ t('4156336694929866466', checkBox6) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.outsourceProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox7 tslTooltip="{{ t('4156336694929866466', checkBox7) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.outsourcePrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox8 tslTooltip="{{ t('4156336694929866466', checkBox8) }}"
                                                ></tsl-checkbox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                i18n="@@8f03c057583a3775d24d2fd879d1f9c085fbed92"
                                                t="8f03c057583a3775d24d2fd879d1f9c085fbed92"
                                                >Maintain</td
                                            >
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.internalProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox9 tslTooltip="{{ t('4156336694929866466', checkBox9) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.internalPrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox10 tslTooltip="{{ t('4156336694929866466', checkBox10) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.outsourceProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox11 tslTooltip="{{ t('4156336694929866466', checkBox11) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.outsourcePrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox12 tslTooltip="{{ t('4156336694929866466', checkBox12) }}"
                                                ></tsl-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <div fxFlex="30">
                                <table class="materials" fxFlex>
                                    <thead>
                                        <tr>
                                            <th
                                                i18n="@@6b19d982e36bff8e6eccce2fd675c0a05230702a"
                                                t="6b19d982e36bff8e6eccce2fd675c0a05230702a"
                                                >Material Class</th
                                            >
                                            <th
                                                i18n="@@d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                                                t="d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                                                >Material Grade</th
                                            >
                                            <th class="tsl-column-action">
                                                <button tsl-icon-button (click)="onAddMaterial(true, item.toolId)">
                                                    <tsl-icon>add_circle</tsl-icon>
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let mat of item?.materials; index as i">
                                            <td>{{ mat.className }}</td>
                                            <td>{{ mat.gradeName }}</td>
                                            <td>
                                                <button tsl-icon-button (click)="onRemoveMaterial(mat.toolId, i, true)">
                                                    <tsl-icon status="error">delete</tsl-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <mat-action-row>
                            <button
                                tsl-icon-button
                                tooltip="Delete" i18n-tooltip="@@Delete" #deleteToolButton tslTooltip="{{ t('Delete', deleteToolButton) }}"
                                tslTooltip="Delete"
                                (click)="onRemoveTool(true, item.toolId)"
                            >
                                <tsl-icon status="error">delete</tsl-icon>
                            </button>
                        </mat-action-row>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </mat-tab>

        <mat-tab label="Equipments">
            <div class="inside-container" fxLayout="column">
                <div fxLayout="row" fxLayoutGap="10px">
                    <div fxFlex="40">
                        <tsl-form-field fxFlex>
                            <tsl-label
                                i18n="@@d9b4e6d7184723bf2a0e1a158b6f9a56f25a11cf"
                                t="d9b4e6d7184723bf2a0e1a158b6f9a56f25a11cf"
                                >Equipments</tsl-label
                            >
                            <tsl-select fullWidth [(ngModel)]="selectedTool">
                                <tsl-option *ngFor="let item of equipments" [value]="item"
                                    >{{ translate.get(item.data.name) }}
                                </tsl-option>
                            </tsl-select>
                        </tsl-form-field>

                        <button
                            tsl-button
                            color="black"
                            size="small"
                            outline
                            (click)="onAddTool(false)"
                            style="margin: 24px;"
                            i18n="@@9e9736df43e489e23c4518f62b387fa12ace4f5a"
                            t="9e9736df43e489e23c4518f62b387fa12ace4f5a"
                            >Add
                        </button>
                    </div>
                </div>

                <mat-accordion [multi]="true">
                    <mat-expansion-panel *ngFor="let item of data.model.equipments">
                        <mat-expansion-panel-header>
                            <mat-panel-title>{{ translate.get(item.toolName) }}</mat-panel-title>
                        </mat-expansion-panel-header>

                        <div>
                            <div fxFlex>
                                <table class="services" fxFlex>
                                    <thead>
                                        <tr>
                                            <th
                                                i18n="@@651956f272ff2f37fbc236e2eef45d1283e87383"
                                                t="651956f272ff2f37fbc236e2eef45d1283e87383"
                                                >Capability Type</th
                                            >
                                            <th
                                                i18n="@@2aa3e81e045266e888ee95684dea616982085892"
                                                t="2aa3e81e045266e888ee95684dea616982085892"
                                                >Internal Production Tool</th
                                            >
                                            <th
                                                i18n="@@255a3de663e5cba73a6479d8cebe4ceb5117b495"
                                                t="255a3de663e5cba73a6479d8cebe4ceb5117b495"
                                                >Internal Prototype Tool</th
                                            >
                                            <th
                                                i18n="@@622dad26f8620b8911e4a59092e9d4f276be069c"
                                                t="622dad26f8620b8911e4a59092e9d4f276be069c"
                                                >Outsource Production Tool</th
                                            >
                                            <th
                                                i18n="@@e6c30beb07fba03f31b3dcd212ceaa9f3e2da557"
                                                t="e6c30beb07fba03f31b3dcd212ceaa9f3e2da557"
                                                >Outsource Prototype Tool</th
                                            >
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td
                                                i18n="@@e0535f9c6a0c61be171755fc908330184d2308d3"
                                                t="e0535f9c6a0c61be171755fc908330184d2308d3"
                                                >Build (weeks lead time)</td
                                            >
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.internalProductionCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox13 tslTooltip="{{ t('4156336694929866466', checkBox13) }}"
                                                    >
                                                    </tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.internalProductionCapable"
                                                        [(ngModel)]="item.buildService.internalProductionTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.internalPrototypeCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox14 tslTooltip="{{ t('4156336694929866466', checkBox14) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.internalPrototypeCapable"
                                                        [(ngModel)]="item.buildService.internalPrototypeTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.outsourceProductionCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox15 tslTooltip="{{ t('4156336694929866466', checkBox15) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.outsourceProductionCapable"
                                                        [(ngModel)]="item.buildService.outsourceProductionTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                            <td>
                                                <div fxLayout="row" fxLayoutGap="2px">
                                                    <tsl-checkbox
                                                        [(ngModel)]="item.buildService.outsourcePrototypeCapable"
                                                        tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox16 tslTooltip="{{ t('4156336694929866466', checkBox16) }}"
                                                    ></tsl-checkbox>
                                                    <input
                                                        tslInput
                                                        type="number"
                                                        min="0"
                                                        tPlaceholder="679000696378615068" i18n-placeholder="@@679000696378615068"
                                                        placeholder="Number of weeks"
                                                        *ngIf="item.buildService.outsourcePrototypeCapable"
                                                        [(ngModel)]="item.buildService.outsourcePrototypeTimeNeeded"
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                i18n="@@695cae7988045be57f186ab95b9f2ddc1c98b5e6"
                                                t="695cae7988045be57f186ab95b9f2ddc1c98b5e6"
                                                >Repair</td
                                            >
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.internalProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox17 tslTooltip="{{ t('4156336694929866466', checkBox17) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.internalPrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox18 tslTooltip="{{ t('4156336694929866466', checkBox18) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.outsourceProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox19 tslTooltip="{{ t('4156336694929866466', checkBox19) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.repairService.outsourcePrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox20 tslTooltip="{{ t('4156336694929866466', checkBox20) }}"
                                                ></tsl-checkbox>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td
                                                i18n="@@8f03c057583a3775d24d2fd879d1f9c085fbed92"
                                                t="8f03c057583a3775d24d2fd879d1f9c085fbed92"
                                                >Maintain</td
                                            >
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.internalProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox21 tslTooltip="{{ t('4156336694929866466', checkBox21) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.internalPrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox22 tslTooltip="{{ t('4156336694929866466', checkBox22) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.outsourceProductionCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox23 tslTooltip="{{ t('4156336694929866466', checkBox23) }}"
                                                ></tsl-checkbox>
                                            </td>
                                            <td>
                                                <tsl-checkbox
                                                    [(ngModel)]="item.maintainService.outsourcePrototypeCapable"
                                                    tooltip="Is Capable" i18n-tooltip="@@4156336694929866466" #checkBox24 tslTooltip="{{ t('4156336694929866466', checkBox24) }}"
                                                ></tsl-checkbox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <div fxFlex="30">
                                <table class="materials" fxFlex>
                                    <thead>
                                        <tr>
                                            <th
                                                i18n="@@6b19d982e36bff8e6eccce2fd675c0a05230702a"
                                                t="6b19d982e36bff8e6eccce2fd675c0a05230702a"
                                                >Material Class</th
                                            >
                                            <th
                                                i18n="@@d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                                                t="d3b4c9f8a200632d59cb8a8f028063e71aadedd5"
                                                >Material Grade</th
                                            >
                                            <th class="tsl-column-action">
                                                <button tsl-icon-button (click)="onAddMaterial(false, item.toolId)">
                                                    <tsl-icon>add_circle</tsl-icon>
                                                </button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let mat of item?.materials; index as i">
                                            <td>{{ mat.className }}</td>
                                            <td>{{ mat.gradeName }}</td>
                                            <td>
                                                <button
                                                    tsl-icon-button
                                                    (click)="onRemoveMaterial(mat.toolId, i, false)"
                                                >
                                                    <tsl-icon status="error">delete</tsl-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <mat-action-row>
                            <button
                                tsl-icon-button
                                tooltip="Delete" i18n-tooltip="@@Delete" #deleteTool tslTooltip="{{ t('Delete', deleteTool) }}"
                                (click)="onRemoveTool(false, item.toolId)"
                            >
                                <tsl-icon status="error">delete</tsl-icon>
                            </button>
                        </mat-action-row>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </mat-tab>
    </mat-tab-group>

    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button size="small" color="blue" filled [disabled]="editForm.invalid" (click)="onSave()" i18n
            >Save</button
        >
    </div>
</ng-container>
